exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-display ul[data-v-a08bf572]{padding:0}.image-display ul li[data-v-a08bf572]{list-style:none;padding:0;text-align:center;padding:5px;display:inline-block}.image-display ul li img[data-v-a08bf572]{max-height:160px;display:block;margin:0 auto}.image-display ul li p.post[data-v-a08bf572]{font-size:small;margin-bottom:4px}.image-display ul li p.post2[data-v-a08bf572]{font-size:small;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a08bf572","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/staff.vue
// module id = 654
// module chunks = 0